$(function() {
    $('[name=product]').on('change', function (e) {
        let product = this.value
        // Reset and show the version field
        $('[name=version]').val('')
        $('[name=version]').addClass('d-none')
        $(`[data-step="version"], [data-step="version"] > [name=version][data-product="${product}"]`).removeClass('d-none')
        $(`[data-step="files"]`).addClass('d-none')
    })

    $('[name=version]').on('change', function (e) {
        let version = this.value
        let product = this.dataset.product
        // Hide all
        $(`[data-step="files"], [data-step="files"] > [data-version][data-product]`).addClass('d-none')
        if (version && product) $(`[data-step="files"], [data-step="files"] > [data-version="${version}"][data-product="${product}"]`).removeClass('d-none')
    })

    $('.logged-only').on('click', function (e) {
        if (this.getAttribute('href') == '#') {
            e.preventDefault()
            $('#modal-info').modal('show')
        }
    })
})